import { US_STATE_CAPITOLS } from '~/constants/regions/us-states';

export type USStateCode = keyof typeof US_STATE_CAPITOLS;

export const US_STATES: ReadonlyArray<{ label: string; value: USStateCode }> = Object.entries(US_STATE_CAPITOLS)
  .map(([code, entry]) => ({ label: entry.name, value: code as USStateCode }))
  .sort((a, b) => a.label.localeCompare(b.label));
